import CandidateDetailsModal from "@/components/AdminDashboard/CandiateDetailsModal";
import api from "@/components/customAxios/Axios";
import useBreadCrumb from "@/context/BreadCrumbContext";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Pagination from "@/components/Pagination";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "@/components/toast";
const Applicants = () => {
	const { setBreadCrumb } = useBreadCrumb();
	const navigate = useNavigate();
	const { setLoading } = useLoader();
	const toast = useToast();
	const [applicants, setApplicants] = useState([]);

	const [searchQuery, setSearchQuery] = useState("");
	const [sortValue, setSortValue] = useState("-created_at");
	const [totalItems, setTotalItems] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	const [selectedStatus, setSelectedStatus] = useState("");

	const statusOptions = [
		"Assessment Sent",
		"Assessment Completed",
		"Assessment Terminated",
	];

	const handleSelect = (status: string) => {
		setSelectedStatus(status === "Clear" ? "" : status);
	};
	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};
	const getApplicants = async () => {
		try {
			setApplicants([]);
			setLoading(true);
			const user_id = localStorage.getItem("user");
			const response = await api.get("/user_applicants_list", {
				params: {
					user_id,

					page: currentPage,
					search_value: searchQuery,
					sort_value: sortValue,
					filter_value: selectedStatus.split(" ")[1] === "Sent" ? "Send" : selectedStatus.split(" ")[1],
					per_page: itemsPerPage,
				},
			});
			if (response.status === 200) {
				setApplicants(response.data.data);
				setTotalItems(response.data.total_count);
				setTotalPages(response.data.total_pages);
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error fetching candidate details",
				description: error.response?.data?.error || error.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		getApplicants();
	}, [selectedStatus, sortValue, currentPage]);

	useEffect(() => {
		// Set a timeout for the search
		const handler = setTimeout(() => {
			getApplicants();
		}, 2000);

		// Cleanup the timeout if searchQuery changes before 2 seconds
		return () => clearTimeout(handler);
	}, [searchQuery]);
	useEffect(() => {
		setItemsPerPage(10);
		setBreadCrumb({
			mainLabel: {
				label: "Applicants",
				link: "applicants",
			},
			currentLabel: "",
		});
	}, []);
	return (
		<div className=" ">
			<div className="bg-white md:p-4  rounded-xl w-full min-h-[85vh]">
				{/* Title */}
				<div className="flex justify-between items-center  font-body">
					<h1 className="text-xl font-semibold  w-full md:w-auto   font-heading mb-3">
						Applicants
					</h1>
				</div>

				<div className="flex justify-between gap-x-1 items-center mb-4 font-body bg-[#F9F9FA] p-1.5 rounded-xl">
					<div className="flex gap-x-3 items-center w-full md:w-auto">
						{/* <div className="ml-2 relative group">
							<Link to="/add-job" className="shadow-md">
								<svg
									width="18"
									height="18"
									viewBox="0 0 18 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M1 9H17"
										stroke="black"
										strokeWidth="1.5"
										strokeLinecap="round"
									/>
									<path
										d="M9 17L9 1"
										stroke="black"
										strokeWidth="1.5"
										strokeLinecap="round"
									/>
								</svg>
							</Link>
							<p className="absolute  w-[100px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
								Create a Job
							</p>
						</div> */}
						<div className="relative group ml-2">
							<DropdownMenu>
								<DropdownMenuTrigger asChild>
									<button className="relative flex items-center gap-2 p-2  rounded hover:bg-gray-100 transition">
										{/* Hamburger Icon */}
										<svg
											width="21"
											height="12"
											viewBox="0 0 21 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M1 1H20"
												stroke="black"
												strokeWidth="1.5"
												strokeLinecap="round"
											/>
											<path
												d="M5 6H16"
												stroke="black"
												strokeWidth="1.5"
												strokeLinecap="round"
											/>
											<path
												d="M9 11H12"
												stroke="black"
												strokeWidth="1.5"
												strokeLinecap="round"
											/>
										</svg>

										{/* Badge */}
										{selectedStatus && (
											<span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
												!
											</span>
										)}
									</button>
								</DropdownMenuTrigger>

								<DropdownMenuContent className="w-56 p-3">
									<DropdownMenuLabel>Status:</DropdownMenuLabel>
									<DropdownMenuSeparator />
									{statusOptions.map((status) => (
										<DropdownMenuItem
											key={status}
											onClick={() => handleSelect(status)}
											className={`${selectedStatus === status
												? "bg-gray-100 font-semibold"
												: ""
												} cursor-pointer`}
										>
											{status}
										</DropdownMenuItem>
									))}
									<DropdownMenuSeparator />
									<DropdownMenuItem
										className="cursor-pointer font-bold"
										onClick={() => handleSelect("Clear")}
									>
										Clear
									</DropdownMenuItem>
								</DropdownMenuContent>
							</DropdownMenu>
							<p className="absolute  w-[60px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
								Filter
							</p>
						</div>
						<div
							className="ml-2 relative group"
							onClick={() =>
								setSortValue((prev) =>
									prev === "-created_at" ? "created_at" : "-created_at"
								)
							}
						>
							<svg
								width="18"
								height="16"
								viewBox="0 0 18 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M14.3536 0.646447C14.1583 0.451184 13.8417 0.451184 13.6464 0.646447L10.4645 3.82843C10.2692 4.02369 10.2692 4.34027 10.4645 4.53553C10.6597 4.7308 10.9763 4.7308 11.1716 4.53553L14 1.70711L16.8284 4.53553C17.0237 4.7308 17.3403 4.7308 17.5355 4.53553C17.7308 4.34027 17.7308 4.02369 17.5355 3.82843L14.3536 0.646447ZM13.5 1L13.5 15H14.5L14.5 1H13.5Z"
									fill="black"
								/>
								<path
									d="M3.64645 15.3536C3.84171 15.5488 4.15829 15.5488 4.35355 15.3536L7.53553 12.1716C7.7308 11.9763 7.7308 11.6597 7.53553 11.4645C7.34027 11.2692 7.02369 11.2692 6.82843 11.4645L4 14.2929L1.17157 11.4645C0.976311 11.2692 0.659728 11.2692 0.464466 11.4645C0.269204 11.6597 0.269204 11.9763 0.464466 12.1716L3.64645 15.3536ZM4.5 15L4.5 1H3.5L3.5 15H4.5Z"
									fill="black"
								/>
							</svg>

							<p className="absolute  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
								Sort
							</p>
						</div>
					</div>

					<div className="flex gap-x-1 items-center w-full md:w-auto">
						<div className="relative  ">
							<span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
								<FiSearch size={"18"} />
							</span>
							<input
								type="text"
								value={searchQuery}
								onChange={(e) => setSearchQuery(e.target.value)}
								placeholder="Search here..."
								className="w-full p-1.5 pl-8 border  border-gray-300 rounded-lg f"
							/>
						</div>
					</div>
				</div>
				<div className="overflow-x-auto px-3  ">
					<div className="max-h-[650px] overflow-y-auto">
						{applicants.length > 0 ? (
							<table className="w-full min-w-[1100px] table-fixed ">
								{/* <ConfirmDialog /> */}
								<thead className="bg-white sticky top-0 text-gray-500 ">
									<tr>
										<th className="py-2 px-1 w-[180px]">Name</th>
										<th className="py-2 px-1 w-[200px]">Job Role</th>

										<th className="py-2 px-1 w-[250px]">Status</th>
										<th className="py-2 px-1 w-[130px]">ATS Score</th>

										<th className="py-2 px-1 w-[150px]">Assessment Score</th>

										<th className="py-2 px-1 w-[150px]">Experience Match</th>
									</tr>
								</thead>

								<tbody className="font-body">
									{applicants.map((item: any, index: number) => (
										<tr className="border-b" key={index}>
											<td
												className="py-3 px-1 font-semibold  text-[#438437] cursor-pointer w-[180px]"
												onClick={() =>
													navigate(
														`/applicants/candidate-resume/${item.job_id}`
													)
												}
											>
												<CandidateDetailsModal
													candidateId={item.job_id}
													candidateName={item.name}
												/>
											</td>
											<td
												className="py-3 px-1  w-[200px] cursor-pointer hover:underline"
												onClick={() =>
													navigate(`/respective-dashboard/${item.candidate_id}`)
												}
											>
												{item.job_name}
											</td>

											<td className="px-2 py-1 w-[250px]">
												<div
													className={`flex items-center ${item.status?.includes("Assessment link send to candidate")
														? "text-[#8183D6]"
														: item.status?.includes("Assessment completed")
															? "text-[#2B9870]"
															: item.status?.includes("Terminated")
																? "text-red-500"
																: "text-[#FFC452]"}`}
												>
													<GoDotFill />
													<span className="ml-1">
														{

															item.status?.includes("Assessment link send to candidate")
																? "Assessment Link Sent to Candidate"
																: item.status?.includes("Assessment completed")
																	? "Assessment Completed"
																	: item.status?.includes("Terminated")
																		? "Assessment Terminated"
																		: "Assessment Not Sent"
														}
													</span>
												</div>
											</td>
											<td className="py-2 px-2 w-[130px]">
												<div className="flex items-center gap-2 pt-2">
													{item.average_primary_score.toFixed(2)}
													{/* {item.resume_skills_match.average_primary_score} */}
													{/* {item.candidate_name !== "Fetching Details" && (
														<ScoreJustificationModal
															jobSkillSet={item.job_skillset}
															resumeSkill={item.resume_skills_match}
														/>
													)} */}
												</div>
											</td>
											<td className="py-3 px-2  dark:text-zinc-400 w-[200px]">
												{item.total_normalized_score || 0}
											</td>
											<td className="py-3 px-1  dark:text-zinc-400 w-[150px]">
												<span
													className={`py-1.5 px-3 rounded-3xl text-md ${item.experience_match === 1
														? "bg-[#BDE4C3] text-[#009617]"
														: "bg-[#F7C5C5] text-[#CA4F4F]"
														}`}
												>
													{item.experience_match === 1 ? "Match" : "Mismatch"}
												</span>
											</td>
										</tr>
									))}
								</tbody>

								<tfoot className="sticky bottom-0 bg-gray-100  font-subheading "></tfoot>
							</table>
						) : (
							<div className="flex justify-center items-center h-[30vh] text-3xl text-gray-500">
								No Candidate
							</div>
						)}
					</div>
				</div>
			</div>
			<Pagination
				dataLength={applicants.length}
				currentPage={currentPage}
				handlePageClick={handlePageClick}
				totalItems={totalItems}
				totalPages={totalPages}
			/>
		</div>
	);
};

export default Applicants;
